<!--
   Created by qing on 2020/2/10 8:15 下午
   Des: 选人组件搜索
-->
<template>
  <div class="search-container">
    <van-search
      shape="round"
      v-model="value"
      placeholder="搜索"
      show-action
      clearable
      @search="onSearch">
      <div slot="action" @click="onCancel">返回</div>
    </van-search>

    <van-list
      class="search-list"
      v-if="searchInfo && (searchInfo.member.length || searchInfo.dep.length || searchInfo.role.length || searchInfo.external.length || searchInfo.externalTag.length)">
      <div
        class="divider"
        v-if="queryType === 'dep' && searchInfo.dep.length">
      </div>
      <!--部门-->
      <van-checkbox-group
        v-if="queryType === 'dep'"
        v-model="selected.dep">
        <van-cell
          v-for="dep in searchInfo.dep"
          :class="{'cell-disabled' : !multiple && available(availableDeps, disableDep, dep.depId)}"
          :key="dep.depId">
          <!--单选-->
          <div
            v-if="!multiple"
            class="list-item dep-item"
            @click="didSelectDepCell(dep)">
            <span>{{dep.depName}}</span>
            <span>{{dep.depPath}}</span>
          </div>
          <!--多选-->
          <div v-else style="width: 100%">
            <van-checkbox
              :disabled="available(availableDeps, disableDep, dep.depId)"
              :name="dep.depId"
              icon-size="16px">
              <div class="list-item dep-item">
                <span>{{dep.depName}}</span>
                <span>{{dep.depPath}}</span>
              </div>
            </van-checkbox>
          </div>
        </van-cell>
      </van-checkbox-group>

      <div
        class="divider"
        v-if="queryType === 'member' && searchInfo.member.length">
      </div>
      <!--人员-->
      <van-checkbox-group
        v-if="queryType === 'member'"
        v-model="selected.member">
        <van-cell
          v-for="item in searchInfo.member"
          :class="{'cell-disabled' : !multiple && available(availableMembers, disableMember, item.userId)}"
          :key="item.userId">
          <van-checkbox
            v-if="multiple"
            :name="item.userId"
            :disabled="available(availableMembers, disableMember, item.userId)"
            icon-size="16px">
            <div class="list-item member-item">
              <van-image
                round
                width="30"
                height="30"
                fit="cover"
                :src="item.headImg">
              </van-image>
              <span>{{item.nickname}}</span>
            </div>
          </van-checkbox>

          <div
            v-else
            class="list-item member-item"
            @click="didSelectMemberCell(item)">
            <van-image
              round
              width="30"
              height="30"
              fit="cover"
              :src="item.headImg">
            </van-image>
            <span>{{item.nickname}}</span>
          </div>
        </van-cell>
      </van-checkbox-group>

      <div
        class="divider"
        v-if="queryType === 'role' && searchInfo.role.length">
      </div>
      <!--角色-->
      <van-checkbox-group
        v-if="queryType === 'role'"
        v-model="selected.role">
        <van-cell
          v-for="role in searchInfo.role"
          :class="{'cell-disabled' : !multiple && available(availableRoles, disableRole, role.roleId)}"
          :key="role.roleId">
          <van-checkbox
            v-if="multiple"
            :name="role.roleId"
            :disabled="available(availableRoles, disableRole, role.roleId)"
            icon-size="16px">
            <div class="list-item member-item">
              <van-image
                v-if="role.roleIcon"
                round
                width="30"
                height="30"
                fit="cover"
                :src="role.roleIcon">
              </van-image>
              <avatar
                v-else
                style="margin-right: 5px"
                backgroundColor="#FFC107"
                :username="role.roleName"
                :size="30">
              </avatar>
              <span>{{role.roleName}}</span>
            </div>
          </van-checkbox>

          <div
            v-else
            class="list-item member-item"
            @click="didSelectRoleCell(role)">
            <van-image
              v-if="role.roleIcon"
              round
              width="30"
              height="30"
              fit="cover"
              :src="role.roleIcon">
            </van-image>
            <avatar
              v-else
              style="margin-right: 5px"
              backgroundColor="#FFC107"
              :username="role.roleName"
              :size="30">
            </avatar>
            <span>{{role.roleName}}</span>
          </div>
        </van-cell>
      </van-checkbox-group>

      <div
        class="divider"
        v-if="queryType === 'external' && searchInfo.external.length">
      </div>
      <!--外部联系人-->
      <van-checkbox-group
        v-if="queryType === 'external'"
        v-model="selected.ext">
        <van-cell
          v-for="ext in searchInfo.external"
          :class="{'cell-disabled' : !multiple && available(availableExt, disableExt, ext.userId)}"
          :key="ext.userId">
          <van-checkbox
            v-if="multiple"
            :name="ext.userId"
            :disabled="available(availableExt, disableExt, ext.userId)"
            icon-size="16px">
            <div class="list-item member-item">
              <van-image
                v-if="ext.headImg"
                round
                width="30"
                height="30"
                fit="cover"
                :src="ext.headImg">
              </van-image>
              <avatar
                v-else
                style="margin-right: 5px"
                backgroundColor="#FFC107"
                :username="ext.orgUserName"
                :size="30">
              </avatar>
              <span>{{ext.orgUserName}}</span>
            </div>
          </van-checkbox>

          <div
            v-else
            class="list-item member-item"
            @click="didSelectExtCell(ext)">
            <van-image
              v-if="ext.headImg"
              round
              width="30"
              height="30"
              fit="cover"
              :src="ext.headImg">
            </van-image>
            <avatar
              v-else
              style="margin-right: 5px"
              backgroundColor="#FFC107"
              :username="ext.orgUserName"
              :size="30">
            </avatar>
            <span>{{ext.orgUserName}}</span>
          </div>
        </van-cell>
      </van-checkbox-group>

      <div
        class="divider"
        v-if="queryType === 'externalTag' && searchInfo.externalTag.length">
      </div>
      <!--外部联系人标签-->
      <van-checkbox-group
        v-if="queryType === 'externalTag'"
        v-model="selected.label">
        <van-cell
          v-for="label in searchInfo.externalTag"
          :class="{'cell-disabled' : !multiple && disableLabel.includes(label.labelId)}"
          :key="label.labelId">
          <van-checkbox
            v-if="multiple"
            :name="label.labelId"
            :disabled="disableLabel.includes(label.labelId)"
            icon-size="16px">
            <div class="list-item member-item">
              <span>{{label.labelName}}</span>
            </div>
          </van-checkbox>

          <div
            v-else
            class="list-item member-item"
            @click="didSelectLabelCell(label)">
            <span>{{label.labelName}}</span>
          </div>
        </van-cell>
      </van-checkbox-group>

    </van-list>
    <div v-else class="empty-container">
      <van-icon name="friends-o"/>
      <div>暂无成员</div>
    </div>
  </div>
</template>

<script>
  import ListContainer from "./ListContainer"
  import Avatar from 'vue-avatar'

  export default {
    props: {
      userId: {
        type: Number,
        default: null
      },
      companyId: {
        type: String,
        default: ''
      },
      // member人员搜索，dep部门搜索，role角色搜索
      queryType: {
        type: String,
        default: 'member'
      },
      // 选中的人员
      selected: Object | null,
      // 是否多选
      multiple: {
        type: Boolean,
        default: true
      },

      // 不可选的部门
      disableDep: {
        type: Array,
        default: () => []
      },
      // 不可选的角色
      disableRole: {
        type: Array,
        default: () => []
      },
      // 不可选的人员
      disableMember: {
        type: Array,
        default: () => []
      },
      // 不可选的外部联系人
      disableExt: {
        type: Array,
        default: () => []
      },
      // 不可选的外部联系人标签
      disableLabel: {
        type: Array,
        default: () => []
      },

      // 部门可选择的 idList
      availableDeps: {
        type: Array,
        default: () => []
      },
      // 成员可选择的 idList
      availableMembers: {
        type: Array,
        default: () => []
      },
      // 角色可选择的 idList
      availableRoles: {
        type: Array,
        default: () => []
      },
      // 外部联系人可选择的 idList
      availableExt: {
        type: Array,
        default: () => []
      },
    },
    components: {
      ListContainer,
      Avatar
    },
    data() {
      return {
        value: '',
        searchInfo: {
          member: [],
          role: [],
          dep: [],
          external: [], // 外部联系人
          externalTag: [] // 外部联系人标签
        }
      };
    },

    methods: {
      available(availableList, disableList, id) {
        if (availableList.length) {
          return !availableList.includes(id)
        } else {
          return disableList.includes(id)
        }
      },
      onSearch(val) {
        if (this.queryType === 'current') return
        this.$store.dispatch('organizationSearch', {
          userId: this.userId,
          companyId: this.companyId,
          queryType: this.queryType,
          queryStr: val
        }).then(res => {
          this.searchInfo = res
          if (!this.searchInfo.external) this.searchInfo.external = []
          if (!this.searchInfo.externalTag) this.searchInfo.externalTag = []
        }).catch(console.error)
      },
      onCancel() {
        this.value = ''
        this.searchInfo.member = []
        this.searchInfo.role = []
        this.searchInfo.dep = []
        this.searchInfo.external = []
        this.searchInfo.externalTag = []
        this.$emit('onCancel')
      },

      // 点击选中部门（单选）
      didSelectDepCell(dep) {
        if (this.available(this.availableDeps, this.disableDep, dep.depId)) {
          this.$toast('不可选择')
        } else {
          this.$emit('didSelectDepCell', dep)
        }
      },
      // 点击选中人员（单选）
      didSelectMemberCell(member) {
        if (this.available(this.availableMembers, this.disableMember, member.userId)) {
          this.$toast('不可选择')
        } else {
          this.$emit('didSelectMemberCell', member)
        }
      },
      // 点击选中角色（单选）
      didSelectRoleCell(role) {
        if (this.available(this.availableRoles, this.disableRole, role.roleId)) {
          this.$toast('不可选择')
        } else {
          this.$emit('didSelectRoleCell', role)
        }
      },
      // 点击选中外部联系人（单选）
      didSelectExtCell(ext) {
        if (this.available(this.availableExt, this.disableExt, ext.userId)) {
          this.$toast('不可选择')
        } else {
          this.$emit('didSelectExtCell', ext)
        }
      },
      // 点击选中外部联系人（单选）
      didSelectLabelCell(label) {
        if (this.disableLabel.includes(label.labelId)) {
          this.$toast('不可选择')
        } else {
          this.$emit('didSelectLabelCell', label)
        }
      },
    }
  };
</script>

<style lang="less">

  .search-container {
    height: 100%;

    .search-list {
      height: calc(100% - 54px);
      overflow: auto;

      .divider {
        width: 100%;
        height: 10px;
        background-color: #F5F5F5;
      }

      .van-cell {
        height: 50px;

        .van-cell__value {
          display: flex;
          align-items: center;
        }

        .van-checkbox {
          width: 100%;

          .van-checkbox__label {
            width: 100%;
          }
        }
      }

      .cell-disabled {
        background-color: #F5F5F5;
        color: #959699;

        .van-image {
          filter: grayscale(100%);
          -webkit-filter: grayscale(100%);
          -moz-filter: grayscale(100%);
          -ms-filter: grayscale(100%);
          -o-filter: grayscale(100%);
        }

        .van-cell__value--alone {
          color: #959699;
        }
      }

      .list-item {
        display: flex;
        align-items: center;
        width: 100%;

        .van-image {
          margin-right: 10px;
        }
      }

      .member-item {
        width: 100%;
      }

      .dep-item {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        font-size: 12px;
        line-height: 12px;

        > :first-child {
          font-size: 14px;
          margin-bottom: 5px;
        }

        > :last-child {
          color: #959699;
        }
      }
    }
  }

</style>